import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-grow-1 m-auto" }
const _hoisted_8 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_9 = { class: "d-flex flex-column" }
const _hoisted_10 = { class: "d-flex align-items-center mb-2" }
const _hoisted_11 = { class: "text-gray-800 text-hover-primary fs-3 fw-bolder me-1" }
const _hoisted_12 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_13 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_14 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Email: ", -1)
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_17 = { class: "d-flex align-items-center text-hover-primary mb-2" }
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Mobile: ", -1)
const _hoisted_20 = { class: "d-flex flex-wrap fw-bold fs-6" }
const _hoisted_21 = { class: "d-flex align-items-center text-hover-primary me-5 mb-2" }
const _hoisted_22 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Present Address: ", -1)
const _hoisted_24 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_25 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap" }
const _hoisted_26 = { class: "nav-item" }
const _hoisted_27 = {
  key: 0,
  class: "card"
}
const _hoisted_28 = { class: "" }
const _hoisted_29 = {
  class: "tab-content",
  id: "kt_tabs"
}
const _hoisted_30 = {
  class: "mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder container m-0 text-primary border-bottom border-2 py-6 px-8" }, " Trainee Details ", -1)
const _hoisted_32 = { class: "card-body p-9" }
const _hoisted_33 = { class: "row mb-2" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Full Name", -1)
const _hoisted_35 = { class: "col-lg-4" }
const _hoisted_36 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Ethnic Group", -1)
const _hoisted_38 = { class: "col-lg-4" }
const _hoisted_39 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_40 = { class: "row mb-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Mobile", -1)
const _hoisted_42 = { class: "col-lg-4 fv-row" }
const _hoisted_43 = { class: "fw-bold fs-6" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Highest Class Completed", -1)
const _hoisted_45 = { class: "col-lg-4" }
const _hoisted_46 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_47 = { class: "row mb-2" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, " Email", -1)
const _hoisted_49 = { class: "col-lg-4 d-flex align-items-center" }
const _hoisted_50 = { class: "fw-bold fs-6 me-2" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Passing Year", -1)
const _hoisted_52 = { class: "col-lg-4" }
const _hoisted_53 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_54 = { class: "row mb-2" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Date of Birth", -1)
const _hoisted_56 = { class: "col-lg-4" }
const _hoisted_57 = { class: "fw-bold fs-6 me-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Is Employed?", -1)
const _hoisted_59 = { class: "col-lg-4" }
const _hoisted_60 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_61 = { class: "row mb-2" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, " NID ", -1)
const _hoisted_63 = { class: "col-lg-4" }
const _hoisted_64 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Years of Experience", -1)
const _hoisted_66 = { class: "col-lg-4" }
const _hoisted_67 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_68 = { class: "row mb-2" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Father's Name", -1)
const _hoisted_70 = { class: "col-lg-4" }
const _hoisted_71 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Personal Monthly Income", -1)
const _hoisted_73 = { class: "col-lg-4" }
const _hoisted_74 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_75 = { class: "row mb-2" }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Mother's Name", -1)
const _hoisted_77 = { class: "col-lg-4" }
const _hoisted_78 = { class: "fw-bold fs-6" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Home District", -1)
const _hoisted_80 = { class: "col-lg-4" }
const _hoisted_81 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_82 = { class: "row mb-2" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Gender", -1)
const _hoisted_84 = { class: "col-lg-4" }
const _hoisted_85 = { class: "fw-bold fs-6" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Home Upazilla", -1)
const _hoisted_87 = { class: "col-lg-4" }
const _hoisted_88 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_89 = { class: "row mb-2" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Religion", -1)
const _hoisted_91 = { class: "col-lg-4" }
const _hoisted_92 = { class: "fw-bold fs-6" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Is Physically Challenged?", -1)
const _hoisted_94 = { class: "col-lg-4" }
const _hoisted_95 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_96 = { class: "row mb-2" }
const _hoisted_97 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Present District:", -1)
const _hoisted_98 = { class: "col-lg-4" }
const _hoisted_99 = { class: "fw-bold fs-6" }
const _hoisted_100 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Remarks", -1)
const _hoisted_101 = { class: "col-lg-4" }
const _hoisted_102 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_103 = { class: "row mb-2" }
const _hoisted_104 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Present Upazilla:", -1)
const _hoisted_105 = { class: "col-lg-4" }
const _hoisted_106 = { class: "fw-bold fs-6" }
const _hoisted_107 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Mother's Education Level", -1)
const _hoisted_108 = { class: "col-lg-4" }
const _hoisted_109 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_110 = { class: "row mb-2" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Present Post Code:", -1)
const _hoisted_112 = { class: "col-lg-4" }
const _hoisted_113 = { class: "fw-bold fs-6" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Mother's Occupation", -1)
const _hoisted_115 = { class: "col-lg-4" }
const _hoisted_116 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_117 = { class: "row mb-2" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Present Address:", -1)
const _hoisted_119 = { class: "col-lg-4" }
const _hoisted_120 = { class: "fw-bold fs-6" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Father's Education Level", -1)
const _hoisted_122 = { class: "col-lg-4" }
const _hoisted_123 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_124 = { class: "row mb-2" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Permanent District:", -1)
const _hoisted_126 = { class: "col-lg-4" }
const _hoisted_127 = { class: "fw-bold fs-6" }
const _hoisted_128 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Father's Occupation", -1)
const _hoisted_129 = { class: "col-lg-4" }
const _hoisted_130 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_131 = { class: "row mb-2" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Permanent Upazilla:", -1)
const _hoisted_133 = { class: "col-lg-4" }
const _hoisted_134 = { class: "fw-bold fs-6" }
const _hoisted_135 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Family Annual Income", -1)
const _hoisted_136 = { class: "col-lg-4" }
const _hoisted_137 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_138 = { class: "row mb-2" }
const _hoisted_139 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Permanent Post Code:", -1)
const _hoisted_140 = { class: "col-lg-4" }
const _hoisted_141 = { class: "fw-bold fs-6" }
const _hoisted_142 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Number of Siblings?", -1)
const _hoisted_143 = { class: "col-lg-4" }
const _hoisted_144 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_145 = { class: "row mb-2" }
const _hoisted_146 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Permanent Address:", -1)
const _hoisted_147 = { class: "col-lg-4" }
const _hoisted_148 = { class: "fw-bold fs-6" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Have family owned home?", -1)
const _hoisted_150 = { class: "col-lg-4" }
const _hoisted_151 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_152 = { class: "row mb-2" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Have family owned land?", -1)
const _hoisted_154 = { class: "col-lg-4" }
const _hoisted_155 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Alternative Mobile", -1)
const _hoisted_157 = { class: "col-lg-4" }
const _hoisted_158 = { class: "fw-bold fs-6 text-dark" }
const _hoisted_159 = { class: "row mb-2" }
const _hoisted_160 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "BCN", -1)
const _hoisted_161 = { class: "col-lg-4" }
const _hoisted_162 = { class: "fw-bold fs-6 text-dark" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: 
                _ctx.traineeInfo?.attach_file_info?.file_path
                  ? _ctx.api_url + _ctx.traineeInfo?.attach_file_info?.file_path
                  : 'media/avatars/blank.png'
              ,
                alt: "",
                width: "100"
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(_ctx.traineeInfo.trainee_name), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("span", _hoisted_14, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _hoisted_15,
                    _createTextVNode(" " + _toDisplayString(_ctx.traineeInfo?.email), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media\\icons\\duotune\\electronics\\elc003.svg" })
                    ]),
                    _hoisted_19,
                    _createTextVNode(" " + _toDisplayString(_ctx.traineeInfo?.mobile), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("span", _hoisted_22, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen018.svg" })
                    ]),
                    _hoisted_23,
                    _createTextVNode(" " + _toDisplayString(_ctx.traineeInfo?.present_address), 1)
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("ul", _hoisted_25, [
            _createElementVNode("li", _hoisted_26, [
              _createElementVNode("a", {
                class: _normalizeClass(["nav-link", { active: _ctx.tabIndex === 0 }]),
                "data-bs-toggle": "tab",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setActiveTab($event))),
                "data-tab-index": "0",
                href: "#overview",
                role: "tab"
              }, " Overview ", 2)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.load]
    ]),
    (_ctx.tabIndex === 0)
      ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass(["tab-pane", { active: _ctx.tabIndex === 0 }]),
                id: "overview"
              }, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, [
                      _hoisted_34,
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.traineeInfo.trainee_name), 1)
                      ]),
                      _hoisted_37,
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.traineeInfo?.ethnic_group?.group_name), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.traineeInfo?.mobile), 1)
                      ]),
                      _hoisted_44,
                      _createElementVNode("div", _hoisted_45, [
                        _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.traineeInfo.highest_class_completed), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _hoisted_48,
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.traineeInfo?.email), 1)
                      ]),
                      _hoisted_51,
                      _createElementVNode("div", _hoisted_52, [
                        _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.traineeInfo.highest_class_completed_year), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_54, [
                      _hoisted_55,
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.traineeInfo?.date_of_birth
                        ? _ctx.moment(_ctx.traineeInfo?.date_of_birth).format(
                            'DD-MM-YYYY'
                          )
                        : _ctx.traineeInfo?.date_of_birth), 1)
                      ]),
                      _hoisted_58,
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.traineeInfo.is_employed), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_61, [
                      _hoisted_62,
                      _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("span", _hoisted_64, _toDisplayString(_ctx.traineeInfo?.nid), 1)
                      ]),
                      _hoisted_65,
                      _createElementVNode("div", _hoisted_66, [
                        _createElementVNode("span", _hoisted_67, _toDisplayString(_ctx.traineeInfo.year_of_experience), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_68, [
                      _hoisted_69,
                      _createElementVNode("div", _hoisted_70, [
                        _createElementVNode("span", _hoisted_71, _toDisplayString(_ctx.traineeInfo?.father_name), 1)
                      ]),
                      _hoisted_72,
                      _createElementVNode("div", _hoisted_73, [
                        _createElementVNode("span", _hoisted_74, _toDisplayString(_ctx.traineeInfo.family_monthly_income), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _createElementVNode("div", _hoisted_77, [
                        _createElementVNode("span", _hoisted_78, _toDisplayString(_ctx.traineeInfo?.mother_name), 1)
                      ]),
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _createElementVNode("span", _hoisted_81, _toDisplayString(_ctx.traineeInfo?.home_district_info?.district_name_eng), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_82, [
                      _hoisted_83,
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("span", _hoisted_85, _toDisplayString(_ctx.traineeInfo?.gender), 1)
                      ]),
                      _hoisted_86,
                      _createElementVNode("div", _hoisted_87, [
                        _createElementVNode("span", _hoisted_88, _toDisplayString(_ctx.traineeInfo?.home_upazilla_info?.upazila_name_eng), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_89, [
                      _hoisted_90,
                      _createElementVNode("div", _hoisted_91, [
                        _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.traineeInfo?.religion), 1)
                      ]),
                      _hoisted_93,
                      _createElementVNode("div", _hoisted_94, [
                        _createElementVNode("span", _hoisted_95, _toDisplayString(_ctx.traineeInfo?.is_physically_challenged), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      _hoisted_97,
                      _createElementVNode("div", _hoisted_98, [
                        _createElementVNode("span", _hoisted_99, _toDisplayString(_ctx.traineeInfo?.present_district_info?.district_name_eng), 1)
                      ]),
                      _hoisted_100,
                      _createElementVNode("div", _hoisted_101, [
                        _createElementVNode("span", _hoisted_102, _toDisplayString(_ctx.traineeInfo?.challenge_remarks), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_103, [
                      _hoisted_104,
                      _createElementVNode("div", _hoisted_105, [
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.traineeInfo?.present_upazilla_info?.upazila_name_eng), 1)
                      ]),
                      _hoisted_107,
                      _createElementVNode("div", _hoisted_108, [
                        _createElementVNode("span", _hoisted_109, _toDisplayString(_ctx.traineeInfo?.mother_education_level), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _hoisted_111,
                      _createElementVNode("div", _hoisted_112, [
                        _createElementVNode("span", _hoisted_113, _toDisplayString(_ctx.traineeInfo?.present_post_code), 1)
                      ]),
                      _hoisted_114,
                      _createElementVNode("div", _hoisted_115, [
                        _createElementVNode("span", _hoisted_116, _toDisplayString(_ctx.traineeInfo?.mother_occupation), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_117, [
                      _hoisted_118,
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("span", _hoisted_120, _toDisplayString(_ctx.traineeInfo?.present_address), 1)
                      ]),
                      _hoisted_121,
                      _createElementVNode("div", _hoisted_122, [
                        _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.traineeInfo?.father_education_level), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_124, [
                      _hoisted_125,
                      _createElementVNode("div", _hoisted_126, [
                        _createElementVNode("span", _hoisted_127, _toDisplayString(_ctx.traineeInfo?.permanent_district_info?.district_name_eng), 1)
                      ]),
                      _hoisted_128,
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("span", _hoisted_130, _toDisplayString(_ctx.traineeInfo?.father_occupation), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_131, [
                      _hoisted_132,
                      _createElementVNode("div", _hoisted_133, [
                        _createElementVNode("span", _hoisted_134, _toDisplayString(_ctx.traineeInfo?.permanent_upazilla_info?.upazila_name_eng), 1)
                      ]),
                      _hoisted_135,
                      _createElementVNode("div", _hoisted_136, [
                        _createElementVNode("span", _hoisted_137, _toDisplayString(_ctx.traineeInfo?.father_annual_income), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_138, [
                      _hoisted_139,
                      _createElementVNode("div", _hoisted_140, [
                        _createElementVNode("span", _hoisted_141, _toDisplayString(_ctx.traineeInfo?.per_post_code), 1)
                      ]),
                      _hoisted_142,
                      _createElementVNode("div", _hoisted_143, [
                        _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.traineeInfo?.number_of_siblings), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_145, [
                      _hoisted_146,
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.traineeInfo?.per_address), 1)
                      ]),
                      _hoisted_149,
                      _createElementVNode("div", _hoisted_150, [
                        _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.traineeInfo?.have_family_owned_home), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_152, [
                      _hoisted_153,
                      _createElementVNode("div", _hoisted_154, [
                        _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.traineeInfo?.have_family_owned_land), 1)
                      ]),
                      _hoisted_156,
                      _createElementVNode("div", _hoisted_157, [
                        _createElementVNode("span", _hoisted_158, _toDisplayString(_ctx.traineeInfo?.alternative_mobile), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_159, [
                      _hoisted_160,
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("span", _hoisted_162, _toDisplayString(_ctx.traineeInfo?.bcn), 1)
                      ])
                    ])
                  ])
                ])
              ], 2)
            ])
          ])
        ])), [
          [_directive_loading, _ctx.load]
        ])
      : _createCommentVNode("", true)
  ], 64))
}